export const environment = {
  Production: true,
  Name: 'VBT Test Ortamı',
  Key: 'VBTTEST',
  ListMoreThan3Months: false,
  BackOfficeUrl: 'https://edonusumtestbo.vbt.com.tr',
  TicariUrl: 'https://edonusumtestapi.vbt.com.tr',
  SmmUrl: 'https://edonusumtestsmmapi.vbt.com.tr',
  EmmUrl: 'https://edonusumtestmmapi.vbt.com.tr',
  TicketUrl: 'http://192.168.11.169:63162',
  BillUrl: 'https://edonusumtestadisyonapi.vbt.com.tr',
  PDFUrl: 'https://edonusumtestapi.vbt.com.tr',
  ExpenseVoucherUrl: 'https://edonusumtestgpapi.vbt.com.tr'
};
